<div class="container">
  <div class="wrapper">
    <h1 class="pageTitle">{{ pageTitle }}</h1>
    <div [innerHTML]="selectedDepartment?.extra?.service_page_guidance_text_1"></div>
    <div [innerHTML]="selectedDepartment?.extra?.service_page_guidance_text_2"></div>
    <div [innerHTML]="selectedDepartment?.extra?.service_page_guidance_text_3"></div>

    <div class="" *ngIf="display_location_and_services_page_permit_guidance">
      <hr>
      <div [innerHTML]="guidanceMsgPermits"></div>
      <div>
        <button tabindex="0" class="btn btn-primary  mt-4 btn-panellink permit-button-padded"
          style="margin-right: 25px;" (click)="continue('/permits',true)">
          <span><span>Apply for Permit</span></span>
        </button>
        <button tabindex="0" class="btn btn-primary  mt-4 btn-panellink permit-button-padded"
          (click)="continue('/amend-permits',true)">
          <span><span>Renew or amend a permit</span></span>
        </button>
      </div>
      <hr>
    </div>

    <div class="row card-row">
      <div class="location-card">
        <div class="card bg-light mb-4 column" tabindex="-1">
          <div class="card-location-header" class="centerText" id="buttonGroup">
            <span *ngFor="let service of servicesList; let i = index">
              <button class="btn btn-primary typeButtons" [ngClass]="{ 'active': selectedServiceIndex === i }" id="{{i}}" role="button"
                (click)="selectInitialSelectedService(service, i)">
                {{ service.name }}
              </button>
            </span>

          </div>


          <!-- <p class="mt-2" *ngIf="location?.address">
                        <span *ngIf="location?.address.address1">{{location.address.address1}}, <br /></span>
                        <span *ngIf="location?.address.address2">{{location.address.address2}}, <br /></span>
                        <span *ngIf="location?.address.address3">{{location.address.address3}}, <br /></span>
                        <span *ngIf="location?.address.address4">{{location.address.address4}}, <br /></span>
                        <span *ngIf="location?.address.address5">{{location.address.address5}}, <br /></span>
                        <span *ngIf="location?.address.postcode">{{location.address.postcode}} <br /></span>
                    </p> -->
        </div>
      </div>
    </div>
    <span id="scroll-center"></span>
    <div class="bottom" *ngIf="initialSelectedService">
      <div>
        <p class="" *ngIf="initialSelectedService?.description">
          <span *ngIf="initialSelectedService?.description" [innerHTML]="initialSelectedService.description" appOpenLinksInNewTab>
            <br /></span>
          <!-- <mat-checkbox id="tickBlock" [(ngModel)]="tickBlock" class="form-group tickBlock"
            *ngIf="initialSelectedService.description.includes('inputCheckbox')"></mat-checkbox> -->
        </p>
      </div>

      <!-- <span *ngIf="!initialSelectedService.permitQuestion">
        <span *ngIf="initialSelectedService?.extra.permits_enabled === 'No'">
          <button tabindex="0" class="btn btn-primary mt-4 btn-panellink botMarg desktop-table" disabled
            *ngIf="!tickBlock" title="Select {{ initialSelectedService.name }}"
            (click)="selectService(initialSelectedService)">
            Continue
          </button>
          <button tabindex="0" class="btn btn-primary mt-4 btn-panellink botMarg desktop-table" *ngIf="tickBlock"
            title="Select {{ initialSelectedService.name }}" (click)="selectService(initialSelectedService)">
            Continue
          </button>
        </span>
        <span *ngIf="initialSelectedService?.extra.permits_enabled === 'Yes'"> -->
          <!-- due to float right these appear onscreen in reverse order -->
          <!-- <div class="form-group">
            <button tabindex="0" class="btn btn-primary mt-4 btn-panellink permit-have-select"
              style="margin-right: 5px;" title="Select {{ initialSelectedService.name }}"
              (click)="askQuestion(initialSelectedService)">
              <span><span>I have a Permit</span></span>
            </button>

            <button tabindex="0" class="btn btn-primary  mt-4 btn-panellink permit-have-select permit-button-padded"
              style="margin-right: 5px;" title="Select {{ initialSelectedService.name }}"
              (click)="applyForPermit(initialSelectedService)">
              <span><span>Apply for Permit</span></span>
            </button>
          </div> -->
        <!-- </span>
      </span> -->
      <div class="form-group" *ngIf="initialSelectedService?.extra.enable_checkbox_for_car_with_trailer === 'Yes'">
        <mat-checkbox [(ngModel)]="tickBlock">
          I confirm that the trailer I am bringing into the site complies with these restrictions
        </mat-checkbox>
      </div>
      
      <span *ngIf="initialSelectedService.permitQuestion && initialSelectedService?.extra.permits_enabled === 'Yes'">
        <div class="permit-questions">
          <div *ngIf="initialSelectedService.status === 0 || initialSelectedService.status === 1">
            <div class="form-group">
              <label for="initialSelectedService.vehicleRegQuestion.id">
                <span aria-hidden="true" class="form-field-required-marker">
                  *</span><span [innerHTML]="' ' + initialSelectedService.vehicleRegQuestion.name"></span>
              </label>
              <input type="text" class="mt-4 btn-panellink" id="initialSelectedService.vehicleRegQuestion.id"
                class="form-control" [(ngModel)]="initialSelectedService.vehicleRegQuestion.answer"
                (keydown.space)="$event.preventDefault()" (keydown.spacebar)="$event.preventDefault()"
                (keydown)="onQuestionChange(initialSelectedService)"
                oninput="this.value = this.value.replace(/\s/g, '').toUpperCase()" />
              <div *ngIf="initialSelectedService.vehicleRegQuestion.empty" class="invalid-feedback">
                Please enter your vehicle registration
              </div>
              <br>
              <label for="email_address">
                <span aria-hidden="true" class="form-field-required-marker">
                  *</span>
                <span [innerHTML]="' Email Address or Mobile Number'"></span>
              </label>
              <input type="text" class="mt-4 btn-panellink" id="email_address" class="form-control"
                [(ngModel)]="initialSelectedService.contact_details.email_address"
                (keydown.space)="$event.preventDefault()" (keydown.spacebar)="$event.preventDefault()"
                (keydown)="onQuestionChange(initialSelectedService)"
                oninput="this.value = this.value.replace(/\s/g, '').toLowerCase()" />
              <div *ngIf="initialSelectedService.contact_details.empty" class="invalid-feedback">
                Please enter either your email or your mobile number
              </div>
              <div *ngIf="initialSelectedService.vehicleRegQuestion.error" class="invalid-feedback">
                <div role="alert" tabindex="0">According to our records there is no active permit linked to this
                  vehicle.
                  <br>
                  Please apply for a permit if you want to visit the site with a van or pickup.
                  <br>
                  <button tabindex="0" class="btn btn-primary  mt-4 btn-panellink permit-have-select"
                    style="margin-right: 5px;" title="Select {{ initialSelectedService.name }}"
                    (click)="applyExternal()">
                    <span><span>Apply for Permit</span></span>
                  </button>
                </div>
              </div>
              <div *ngIf="initialSelectedService.vehicleRegQuestion.apiError" class="invalid-feedback">
                <div role="alert" tabindex="0">
                  {{ initialSelectedService.vehicleRegQuestion.apiError }}
                </div>
              </div>
              <div *ngIf="initialSelectedService.vehicleRegQuestion.apiNote" class="invalid-feedback">
                <div role="alert" tabindex="0" style="color: black"
                  [innerHTML]="initialSelectedService.vehicleRegQuestion.apiNote">
                </div>
              </div>
              <div *ngIf="initialSelectedService.vehicleRegQuestion.apiSuccess" class="invalid-feedback">
                <div role="alert" tabindex="0" style="color: #008000">
                  {{ initialSelectedService.vehicleRegQuestion.apiSuccess }}
                </div>
              </div>
            </div>
            <div *ngIf="initialSelectedService.renewButton" class="form-group botMarg" style="margin-top: -30px">
              <span>
                <button tabindex="0" class="btn btn-primary mt-4 btn-panellink" style="margin-right: 20px !important"
                  title="Cancel" (click)="renewPermit(initialSelectedService)">
                  Renew your permit
                </button>
                <br>
              </span>

              <!-- <button *ngIf="!initialSelectedService.showContinue" tabindex="0" class="btn btn-primary mt-4 btn-panellink"
                style="margin-right: 20px !important" title="Cancel" (click)="cancelPermit(initialSelectedService)">
                Cancel
              </button>
              <button *ngIf="initialSelectedService.showContinue" tabindex="0"
                class="btn btn-primary mt-4 btn-panellink" style="margin-right: 20px !important" title="Cancel"
                (click)="cancelReg(initialSelectedService)">
                Cancel
              </button> -->
              <!-- <span *ngIf="!initialSelectedService.showContinue">

                <button tabindex="0" class="btn btn-primary mt-4 btn-panellink" title="Check"
                  (click)="checkVehicleReg(initialSelectedService)">
                  Check Permit
                </button>
              </span> -->
              <!-- <span *ngIf="initialSelectedService.showContinue">
                <button tabindex="0" class="btn btn-primary mt-4 btn-panellink" title="Check"
                  (click)="selectService(initialSelectedService)">
                  Continue
                </button>
              </span> -->

            </div>
          </div>
          <!-- <div *ngIf="initialSelectedService.status === 1">
            <div class="form-group botMarg">
              <label for="initialSelectedService.permitQuestion.id">
                <span aria-hidden="true" class="form-field-required-marker">
                  *</span>
                <span [innerHTML]="initialSelectedService.permitQuestion.name"></span>
              </label>
              <input type="number" class="mt-4 btn-panellink" id="initialSelectedService.permitQuestion.id"
                class="form-control" [(ngModel)]="initialSelectedService.permitQuestion.answer"
                [disabled]="initialSelectedService.status !== 0 || initialSelectedService.showContinue" />
              <div *ngIf="initialSelectedService.permitQuestion.error" class="invalid-feedback">
                <div role="alert" tabindex="0">Please complete</div>
              </div>
              <div *ngIf="initialSelectedService.permitQuestion.apiError" class="invalid-feedback">
                <div role="alert" tabindex="0">
                  {{ initialSelectedService.permitQuestion.apiError }}
                </div>
              </div>
              <div *ngIf="initialSelectedService.permitQuestion.apiNote" class="invalid-feedback">
                <div role="alert" tabindex="0" style="color: black"
                  [innerHTML]="initialSelectedService.permitQuestion.apiNote">
                </div>
              </div>
              <div *ngIf="initialSelectedService.permitQuestion.apiSuccess" class="invalid-feedback">
                <div role="alert" tabindex="0" style="color: #008000">
                  {{ initialSelectedService.permitQuestion.apiSuccess }}
                </div>
              </div>
            </div>
            <div *ngIf="initialSelectedService.status === 1" class="form-group" style="margin-top: -30px">
              <button *ngIf="!initialSelectedService.showContinue" tabindex="0"
                class="btn btn-primary mt-4 btn-panellink" style="margin-right: 20px !important" title="Cancel"
                (click)="initialSelectedService.permitQuestion = false">
                Cancel
              </button>
              <button *ngIf="initialSelectedService.showContinue" tabindex="0"
                class="btn btn-primary mt-4 btn-panellink" style="margin-right: 20px !important" title="Cancel"
                (click)="cancelPermit(initialSelectedService)">
                Cancel
              </button>
              <button *ngIf="!initialSelectedService.showContinue" tabindex="0"
                class="btn btn-primary mt-4 btn-panellink" title="Check" (click)="checkPermit(initialSelectedService)">
                Check Permit
              </button>
              <button *ngIf="initialSelectedService.showContinue" tabindex="0"
                class="btn btn-primary mt-4 btn-panellink" title="Check"
                (click)="selectService(initialSelectedService)">
                Continue
              </button>
            </div>
          </div> -->
        </div>
      </span>
    </div>

    <div class="location-card min-btn-height">
      <!-- <button type="button" class="btn btn-primary" (click)="routerGoBack()" title="Back"
        aria-label="Back to booking details">
        <span><fa-icon [icon]="faChevronLeft"></fa-icon><span>{{ 'COMMON.BACK' | translate }}</span></span>
      </button> -->
      <ng-container *ngIf="!initialSelectedService?.permitQuestion">
        <ng-container *ngIf="initialSelectedService?.extra.permits_enabled === 'No'">
            <button tabindex="0" class="btn btn-primary btn-panellink float-right" disabled
              *ngIf="!tickBlock" title="Select {{ initialSelectedService.name }}"
              (click)="selectService(initialSelectedService)">
              Continue <fa-icon [icon]="faChevronRight"></fa-icon>
            </button>
            <button tabindex="0" class="btn btn-primary btn-panellink float-right" *ngIf="tickBlock"
              title="Select {{ initialSelectedService.name }}" (click)="selectService(initialSelectedService)">
              Continue <fa-icon [icon]="faChevronRight"></fa-icon>
            </button>
        </ng-container>
      </ng-container>

      <!-- permit check -->
      <ng-container *ngIf="initialSelectedService && initialSelectedService.permitQuestion && initialSelectedService?.extra.permits_enabled === 'Yes'">
        <ng-contaner *ngIf="initialSelectedService.status === 0 || initialSelectedService.status === 1">
          <span *ngIf="!initialSelectedService.showContinue">
            <button tabindex="0" class="btn btn-primary btn-panellink float-right" title="Check"  
              (click)="checkVehicleReg(initialSelectedService)">
              Check Permit
            </button>
          </span>
          <span *ngIf="initialSelectedService.showContinue">
            <button tabindex="0" class="btn btn-primary btn-panellink float-right" title="Check"
              (click)="selectService(initialSelectedService)">
              Continue <fa-icon [icon]="faChevronRight"></fa-icon>
            </button>
          </span>
        </ng-contaner>
      </ng-container>
    </div>
  </div>
</div>